import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import HouseholdInfoSection from './HouseholdInfoSection/HouseholdInfoSection';

const HouseholdInfoSectionPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.transitionsDashboardHouseholdInfo.name]: (<HouseholdInfoSection relationship={resource.relationship(fr.relationships.transitionsDashboardHouseholdInfo.name).link('related')} />),
  }, null);
};

HouseholdInfoSectionPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
HouseholdInfoSectionPicker.defaultProps = {};

export default HouseholdInfoSectionPicker;
